import EventBus from '@/components/mixins/event-bus-mixin'
import CommonOptionsMixin from '@/components/mixins/common-options-mixin'
import FontListComp from '@/components/common/font-list/font-list-tmpl'
import MediaListComp from '@/components/common/media-list/media-list-tmpl'
import UnsavedDataMixin from '@/components/mixins/unsaved-data-mixin'
import tagMenuItem from '@/components/common/tags/tags-tmpl'
import { mapState as piniaMapState } from 'pinia'
import { useFileUploaderStore } from '@/pinia/stores/file-upload/fileUploaderStore'
import { FwbTooltip } from 'flowbite-vue'

const TEMPLATE_STYLE_PROPERTIES = ['name', 'logo', 'backgroundColor', 'font', 'textColor', 'tags']

export default {
  name: 'create-template-properties',
  inject: [
    '$currentUser',
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  components: {
    mediaList: MediaListComp,
    fontList: FontListComp,
    tagMenuItem,
    FwbTooltip
  },
  props: {
    templateProp: {
      type: Object,
      default () { return {} }
    },
    templateMenuTypeProp: {
      type: String,
      default () { return null }
    },
    countTemplateSetsProp: {
      type: Number,
      default () { return 1 }
    },
    maxCountTemplateSetsProp: {
      type: Number,
      default () { return 3 }
    },
    tagsSummaryProp: {
      default () { return [] }
    }
  },
  computed: {
    ...piniaMapState(useFileUploaderStore, {
      fileUploaderState: 'uploadedFiles'
    }),
    colorPickersRgb () {
      return {
        logoColor: this.$utils.hexToRgb(this.templateEdit.options.logoColor),
        backgroundColor: this.$utils.hexToRgb(this.templateEdit.options.backgroundColor),
        foregroundColor: this.$utils.hexToRgb(this.templateEdit.options.foregroundColor)
      }
    }
  },
  watch: {
    fileUploaderState (newVal) {
      if (newVal.prevAction === 'processNewFilesWithInstance') {
        const data = []
        newVal.files.forEach(file => {
          if (file._edit && file._edit.uploadRequests.createMediaInstanceResponseData) data.push(file._edit.uploadRequests.createMediaInstanceResponseData)
        })
        this.handleMediaListChange({ action: 'MEDIA_SELECTION', payload: { data } })
      }
    },
    templateProp (newTemplate) {
      this.setDefaultData(newTemplate)
    },
    templateMenuTypeProp (newTemplateMenuType) {
      this.templateMenuType = newTemplateMenuType
    },
    countTemplateSetsProp (newCcountTemplateSetsProp) {
      this.countTemplateSets = newCcountTemplateSetsProp
      this.handleShowSubmitButton()
    },
    tagsSummaryProp: {
      handler (newTagsSummary) {
        this.tagsSummary = newTagsSummary
      },
      deep: true
    }
  },
  mixins: [CommonOptionsMixin, UnsavedDataMixin],
  data () {
    return {
      currentSelectedLogoType: null,
      error: '',
      editableOptionProperties: TEMPLATE_STYLE_PROPERTIES.filter((prop) => prop !== 'name'),
      editedOptionProperties: [],
      templateInit: [],
      templateEdit: this.templateProp,
      templateMenuType: this.templateMenuTypeProp,
      countTemplateSets: this.countTemplateSetsProp,
      maxCountTemplateSets: this.maxCountTemplateSetsProp,
      mediaListDialog: {
        filterType: '',
        filterTypeOptions: ['img', 'video'],
        mediaSelection: [],
        isVisible: false
      },
      optionProperties: [
        {
          id: TEMPLATE_STYLE_PROPERTIES[0],
          name: this.$t('label.styleName'),
          editable: false
        },
        {
          id: TEMPLATE_STYLE_PROPERTIES[1],
          name: this.$t('label.logo'),
          editable: true
        },
        {
          id: TEMPLATE_STYLE_PROPERTIES[2],
          name: this.$t('label.shapeColors'),
          editable: true
        },
        {
          id: TEMPLATE_STYLE_PROPERTIES[3],
          name: this.$t('label.text'),
          editable: true
        },
        {
          id: TEMPLATE_STYLE_PROPERTIES[4],
          name: '',
          editable: true
        },
        {
          id: TEMPLATE_STYLE_PROPERTIES[5],
          name: this.$t('label.defaultTags'),
          editable: true
        }
      ],
      sections: [{
        id: TEMPLATE_STYLE_PROPERTIES[0],
        index: 0
      },
      {
        id: TEMPLATE_STYLE_PROPERTIES[1],
        index: 1
      },
      {
        id: TEMPLATE_STYLE_PROPERTIES[2],
        index: 2
      },
      {
        id: 'textProperties',
        children: [
          {
            id: TEMPLATE_STYLE_PROPERTIES[3],
            index: 3
          },
          {
            id: TEMPLATE_STYLE_PROPERTIES[4],
            index: 4
          }
        ]
      },
      {
        id: TEMPLATE_STYLE_PROPERTIES[5],
        index: 5
      }],
      projectOrientation: 'horizontal',
      showSubmitButton: false,
      predefineColors: ['#f5977d', '#fcc58e', '#fff69f', '#a4d29e', '#7eccc7', '#72d0f4', '#a088bd', '#f29cc1', '#c6b19a', '#ffffff',
        '#f06d54', '#f9ae64', '#fff372', '#7ec379', '#2abab3', '#00afec', '#8561a6', '#ee70a9', '#988676', '#cccccc',
        '#eb212e', '#f59331', '#fff02a', '#40b34f', '#00a89c', '#0057a4', '#65318f', '#ea148c', '#726258', '#959595',
        '#9c0f17', '#f0662f', '#ab9f1d', '#007138', '#00736a', '#003670', '#441461', '#9c005d', '#534741', '#464646',
        '#780002', '#9e4218', '#827a0d', '#005727', '#005951', '#002355', '#310049', '#790046', '#36302e', '#000000'],
      tagsSummary: this.tagsSummaryProp,
      selectedTagsFromSlider: [],
      templateSetTags: [],
      tagOptions: [],
      enableTags: false
    }
  },
  methods: {
    setDefaultData (newTemplate) {
      const templateEdit = this.$utils.clone(newTemplate)

      // We should set the template name to empty string
      if (this.templateMenuType === 'newTemplateSet') {
        templateEdit.name = 'STYLE'
      }

      this.templateInit = templateEdit
      this.templateEdit = templateEdit
      this.editableOptionProperties = TEMPLATE_STYLE_PROPERTIES.filter((prop) => prop !== 'name')

      // Reset Option Properties data
      this.editedOptionProperties = []
      this.optionProperties = this.filterOptionProperties(this.optionProperties)

      if (this.$currentUser.getUserTags().length && this.templateEdit.groupId === 'default') {
        this.templateEdit.tags = this.$currentUser.getUserTags()
      }
      this.tagOptions = this.templateEdit.tags ? this.templateEdit.tags : []

      if (this.$currentUser.getUserTags().length) {
        this.tagsSummary = this.$utils.filterTagOptionsForUI({ tags: this.$currentUser.getUserTags() })
      }

      this.enableTags = false
      if (this.$currentUser.hasGroupTagsUser()) {
        if (!this.$currentUser.getUserTags().length && this.$currentUser.getRights().userCreate.displayTags) {
          this.enableTags = true
        } else if (this.$currentUser.getUserTags().length) {
          const currentTags = this.$currentUser.getUserTags()
          const templateTags = this.tagOptions
          const hasCommonTags = templateTags.find((tag) => { return currentTags.includes(tag) })

          if (hasCommonTags) this.enableTags = true
          this.enableTags = false // force to hide tags
        }
      }

      this.handleShowSubmitButton()
    },
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('properties-change', { action, payload: { data } })
      }
    },
    handleSelectLogoClick () {
      const templateEdit = this.$utils.clone(this.templateEdit)
      let mediaListDialog = this.$utils.clone(this.mediaListDialog)

      mediaListDialog = {
        filterType: (this.currentSelectedLogoType !== null) ? this.currentSelectedLogoType : 'img',
        filterTypeOptions: ['img', 'video'],
        mediaSelection: [templateEdit.options.logo],
        isVisible: true
      }

      this.projectOrientation = this.$dataStore.getMediaOrientation()
      this.mediaListDialog = mediaListDialog
    },
    /**
     * Hook function when mediaList sub-component change or throw an event
     * @param {Object} event - event object data
     */
    handleMediaListChange (event) {
      if (event.action === 'MEDIA_SELECTION') {
        const mediaSelection = event.payload.data
        let logo = {}

        // Media selection is not empty, then set logo from selection
        if (mediaSelection.length >= 1) {
          logo = mediaSelection[0]
        }

        // Media selection is empty then get it's original value
        if (mediaSelection.length === 0) {
          logo = this.templateInit.options.logo
        }

        // Update Template
        const templateEdit = this.$utils.clone(this.templateEdit)
        templateEdit.options.logo = logo
        this.templateEdit = templateEdit

        // Update media list dialog
        const mediaListDialog = this.$utils.clone(this.mediaListDialog)
        mediaListDialog.isVisible = false
        this.mediaListDialog = mediaListDialog

        // Set logo property as edited or changed
        this.handlePropertyChange('logo')

        // Set Current selected logo type
        this.currentSelectedLogoType = logo.type

        // Preview
        this.handleTemplateSetPreview()
      }
    },
    handleTemplateSetPreview (params = {}) {
      this.emitEvent('TEMPLATE_SET_PREVIEW', { template: this.$utils.clone(this.templateEdit), eventAction: params.eventAction })
    },
    handleSubmitButtonClick () {
      const template = this.$utils.clone(this.templateEdit)
      const requestData = this.$utils.clone(this.templateEdit)

      // Filter request data
      requestData.name = template.name
      requestData.tags = template.tags ? template.tags : undefined
      requestData.options.logo = {
        resourceId: template.options.logo.resourceId
      }

      // Update Template set
      if (template.userDefined === true) {
        const apiRequest = () => {
          this.$utils.mainLoader(true)

          this.$api.put(`${CONFIG.API_BASE_URL}/template/${template.templateSetId}`, requestData)
            .then(response => {
              this.emitEvent('TEMPLATE_SET_UPDATED', response.data)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
            })
        }
        apiRequest()
      }

      // Create new template set
      if (template.userDefined === false) {
        this.$utils.mainLoader(true)

        if (requestData.name.length < 1) {
          requestData.name = `STYLE-${this.countTemplateSets}`
        }

        const apiRequest = () => {
          this.$api.post(`${CONFIG.API_BASE_URL}/template`, requestData)
            .then(response => {
              this.emitEvent('NEW_TEMPLATE_SET_CREATED', response.data)
            })
            .catch((error) => {
              this.$utils.mainLoader(false)
              this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
            })
        }
        apiRequest()
      }

      this.removeUnsavedDataFlagInLocalStorage()
    },
    /**
     * Handle Option property on click
     * @param {String} propertyId -  selected property id
     */
    handlePropertyClick (propertyId) {
      const editableOptionProperties = this.editableOptionProperties

      if (editableOptionProperties.indexOf(propertyId) < 0) {
        editableOptionProperties.push(propertyId)
      }
      this.editableOptionProperties = editableOptionProperties
      this.optionProperties = this.filterOptionProperties(this.optionProperties, false)

      if (propertyId === 'name') {
        this.$nextTick(_ => {
          this.$refs.styleInputName[0].select()
        })
      }
    },
    /**
     * Handle Option property data on change
     * @param {String} propertyId - selected property id
     */
    handlePropertyChange (propertyId) {
      const editedOptionProperties = this.editedOptionProperties

      if (editedOptionProperties.indexOf(propertyId) < 0) {
        editedOptionProperties.push(propertyId)
      }

      if (propertyId === 'name' && this.editableOptionProperties.indexOf('name') >= 0) {
        this.editableOptionProperties = this.editableOptionProperties.filter((item) => { return item !== 'name' })
        this.optionProperties = this.filterOptionProperties(this.optionProperties, false)
      }

      this.setUnsavedDataFlagIntoLocalstorage({ page: 'createEditTemplateSet' })
      this.handleShowSubmitButton()
    },
    handleColorSwatchChange (valueRgb, propertyId, model) {
      this.handlePropertyChange(propertyId)

      const valRgbToHex = (this.$utils.rgbToHex(valueRgb) || '').toUpperCase()

      const templateEdit = this.$utils.clone(this.templateEdit)
      templateEdit.options[model] = valRgbToHex

      this.templateEdit = templateEdit
      this.handleTemplateSetPreview()
    },
    /**
     * Filter Option properties
     * @param {Object} mediaPropertiesSrc - media properties to update
     * @param {Boolean} resetSelected - reset selected
     */
    filterOptionProperties (optionPropertiesSrc, resetSelected) {
      const optionProperties = this.$utils.clone(optionPropertiesSrc)
      const editableOptionProperties = this.editableOptionProperties

      for (const i in optionProperties) {
        const optionProp = optionProperties[i]

        optionProp.editable = false
        if ((editableOptionProperties.indexOf(optionProp.id) >= 0) && (!resetSelected)) {
          optionProp.editable = true
        }
      }
      return optionProperties
    },
    handleShowSubmitButton () {
      let showSubmitButton = false

      if (this.templateEdit.userDefined === false) {
        showSubmitButton = true
      }

      if (this.templateEdit.userDefined && this.editedOptionProperties.length > 0) {
        showSubmitButton = true
      }

      if (this.templateEdit._newUploadedFont) {
        showSubmitButton = true

        delete this.templateEdit._newUploadedFont
      }

      this.showSubmitButton = showSubmitButton
    },
    handleFontListChange (event) {
      if (['FONT_SELECTION_CHANGE', 'FONT_UPLOAD_DONE'].indexOf(event.action) >= 0) {
        const templateEdit = this.$utils.clone(this.templateEdit)
        templateEdit.options.fontFamily = event.payload.data.fontSelection

        this.templateEdit = templateEdit
        this.handlePropertyChange('font')
        this.handleTemplateSetPreview({ eventAction: event.action })
      }
    },
    handleDialogClose () {
      this.mediaListDialog.isVisible = false
      EventBus.$emit('MEDIA_PICKER_CLOSED')

      if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
        $('.project-frame-content').removeClass('hide-project-iframe')
      }
    },
    handleTagMenuItemChange (event) {
      if ((event.action === 'TAGS_UPDATED' || event.action === 'TAG_REMOVED')) {
        const templateEdit = this.$utils.clone(this.templateEdit)
        templateEdit.tags = event.payload.data.tags
        this.templateEdit = templateEdit
        this.handlePropertyChange('tags')
      }
    }
  },
  mounted () {
    this.setDefaultData(this.templateEdit)
  }
}
